import type { Filter } from './filters'
import { apiFilterSchema, filterSchema } from './filters'
import { z } from 'zod'

export const searchQuerySchema = z.object({
  query: z.string(),
  type: z
    .enum(['description', 'patent_number', 'keyword'])
    .default('description'),
  max_results: z.number().positive().default(100),
  filters: apiFilterSchema.optional(),
  refine_enabled: z.boolean().default(false),
})

export type SearchQuery = z.infer<typeof searchQuerySchema>

export const searchQueryApiSchema = searchQuerySchema
  .extend({
    id: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    count: z.number().nonnegative().default(0),
  })
  .describe('Search Query Type')

export type SearchQueryAPI = z.infer<typeof searchQueryApiSchema>

export type SearchQueryWithProcessedFiltersAPI = Omit<
  SearchQueryAPI,
  'filters'
> & {
  filters: Filter
}

export const searchQueryWithFiltersSchema = searchQueryApiSchema.extend({
  filters: filterSchema,
})

export type SearchQueryWithFiltersAPI = z.infer<
  typeof searchQueryWithFiltersSchema
>

export const keywordFilterSchema = apiFilterSchema.pick({
  keyword_text_query: true,
  keyword_opensearch_query: true,
})

export type KeywordFilter = z.infer<typeof keywordFilterSchema>

export const searchQueryCreateSchema = searchQuerySchema.extend({
  filters: keywordFilterSchema.optional(),
})

export const searchQueryResponseSchema = z.object({
  data: searchQueryApiSchema,
  message: z.string(),
})

export type SearchQueryResponse = z.infer<typeof searchQueryResponseSchema>
